import CommonConstants from '../constants/CommonConstants';
import ApiConstants from '../constants/ApiConstants';
import axios from 'axios';

let ReportActions = {
	getReportDataError: function(error) {
		return {
			error,
			type: CommonConstants.GET_REPORT_DATA_ERROR
		};
	},

	getReportDataSuccess: function(response) {
		return {
			response,
			type: CommonConstants.GET_REPORT_DATA_SUCCESS
		};
	},

	getReportData: function(cb){
        let token = localStorage.getItem('accessToken');
        let user_id = localStorage.getItem('userId');
        return dispatch => {
			axios({
				url: `${ApiConstants.getApiPath()}api/v1/users/${user_id}/nutritional-report`,
				method: 'GET',
				responseType: 'arraybuffer',
				headers: {
					'Authorization': `Bearer ${token}`,
					'Accept-Language': 'fr-FR'
				}            
			})
			.then((response) => {
				console.log(response);
				if(response.status === 200) {
					let blob = response.data;
					const url = window.URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}));
					dispatch(this.getReportDataSuccess(url));
					cb(url);	
				}else {
					let _error={
						status: response.status,
						error: response.statusText
					};
					dispatch(this.getReportDataError(_error));
					cb(_error);
				}
			})
			.catch(error => {
				// handle error
				let response = error.response;
				let _error={
					status: response.status,
					error: response.statusText
				};
				console.log(_error);
				dispatch(this.getReportDataError(_error));
				cb(_error);
			});
		};
	}

};

export default ReportActions;


// WEBPACK FOOTER //
// ./actions/ReportActions.js